import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, Transition as _Transition, resolveComponent as _resolveComponent, resolveDynamicComponent as _resolveDynamicComponent } from "vue"
import _imports_0 from './assets/avexo.png'


const _hoisted_1 = {
  id: "navbar",
  class: "fixed top-0 z-40 flex w-full flex-row items-center bg-parrot px-4 justify-between border-b border-gray-200"
}
const _hoisted_2 = { class: "sticky justify-center top-0 z-40 flex h-12 shrink-0 items-center gap-x-4 bg-parrot px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Abrir menu", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "hidden lg:block" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-auto h-10",
    alt: "Avexo logo",
    src: _imports_0
  })
], -1)
const _hoisted_5 = { class: "flex-row items-center py-1 text-lg text-white sm:flex" }
const _hoisted_6 = { class: "flex flex-1 gap-x-4 self-stretch lg:gap-x-6" }
const _hoisted_7 = { class: "flex items-center gap-x-4 lg:gap-x-6" }
const _hoisted_8 = {
  key: 0,
  class: "flex items-center my-2"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "w-16 h-8 mr-2 p-1.5 border-parrot-1 border rounded-md bg-white bg-opacity-20 animate-pulse flex-shrink-0" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center p-1.5 border-parrot-1 border rounded-md w-44 lg:w-52 animate-pulse" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-10 h-10 mr-2 rounded bg-white bg-opacity-20 animate-pulse flex-shrink-0" }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col flex-1" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "flex items-center" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "h-4 bg-white bg-opacity-30 rounded w-24" })
    ]),
    /*#__PURE__*/_createElementVNode("span", { class: "flex items-center mt-1" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "h-3 bg-white bg-opacity-20 rounded w-32" })
    ])
  ])
], -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "flex items-center my-2"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Abrir empresas", -1)
const _hoisted_14 = {
  key: 0,
  class: "mr-2 flex-shrink-0"
}
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = { class: "flex items-center" }
const _hoisted_17 = {
  class: "text-sm font-semibold leading-6 text-white line-clamp-1 truncate",
  "aria-hidden": "true"
}
const _hoisted_18 = { class: "flex items-center" }
const _hoisted_19 = {
  class: "text-sm leading-6 text-white truncate",
  "aria-hidden": "true"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-900/80" }, null, -1)
const _hoisted_21 = { class: "fixed inset-0 flex" }
const _hoisted_22 = { class: "absolute left-full top-0 flex w-16 justify-center pt-5" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close sidebar", -1)
const _hoisted_24 = { class: "flex grow flex-col gap-y-5 overflow-y-auto bg-parrot px-4 py-10 pb-4" }
const _hoisted_25 = { class: "border-b border-white border-opacity-20 pb-4" }
const _hoisted_26 = { class: "flex items-center p-3 border border-white border-opacity-20 rounded-lg" }
const _hoisted_27 = {
  key: 0,
  class: "mr-4 flex-shrink-0"
}
const _hoisted_28 = ["src", "alt"]
const _hoisted_29 = { class: "text-base font-semibold truncate" }
const _hoisted_30 = { class: "text-sm opacity-75 truncate" }
const _hoisted_31 = { class: "flex flex-1 flex-col" }
const _hoisted_32 = {
  role: "list",
  class: "flex flex-1 flex-col gap-y-7"
}
const _hoisted_33 = {
  role: "list",
  class: "-mx-2 space-y-1"
}
const _hoisted_34 = ["href"]
const _hoisted_35 = { class: "mt-auto" }
const _hoisted_36 = { class: "hidden lg:fixed lg:inset-y-0 lg:z-30 lg:mt-16 lg:flex lg:w-60 lg:flex-col" }
const _hoisted_37 = { class: "flex grow flex-col gap-y-5 overflow-y-auto bg-parrot px-4 py-10 pb-4" }
const _hoisted_38 = { class: "flex flex-1 flex-col" }
const _hoisted_39 = {
  role: "list",
  class: "flex flex-1 flex-col gap-y-7"
}
const _hoisted_40 = {
  role: "list",
  class: "-mx-2 space-y-1"
}
const _hoisted_41 = ["href"]
const _hoisted_42 = { class: "mt-auto" }
const _hoisted_43 = { class: "lg:pl-60 pt-14 mx-auto" }
const _hoisted_44 = { class: "py-10" }
const _hoisted_45 = { class: "px-4 sm:px-6 lg:px-8" }

import { ref, provide, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import {
  Dialog,
  DialogPanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import ClientListSkeleton from "@/components/skeleton/client-list-skeleton.vue";
import {
  Bars3Icon,
  // Cog6ToothIcon,
  // LogoutIcon,
  ArrowLeftEndOnRectangleIcon,
  CheckIcon,
} from "@heroicons/vue/24/outline";
import {
  ChevronDownIcon,
  ChartPieIcon,
  // QuestionMarkCircleIcon,
} from "@heroicons/vue/20/solid";

import SaleIcon from "@/components/icons/sale-icon";
import KeycloakService from "@/security/keycloak-service";
import HttpService from "@/services/http-service";
import ReceiptIcon from "@/components/icons/receipt-icon";
import DashboardIcon from "@/components/icons/dashboard-icon";


export default /*#__PURE__*/_defineComponent({
  __name: 'app',
  setup(__props) {

const httpService = HttpService.getAxiosClient();

const navigation = [
  {
    name: "Início",
    href: "/",
    icon: DashboardIcon,
  },
  { name: "Clientes", href: "/clientes", icon: SaleIcon },
  { name: "Cobranças", href: "/cobrancas", icon: ReceiptIcon },
  {
    name: "Recebimentos",
    href: "/financeiro",
    icon: ChartPieIcon,
  },
];

const route = useRoute();
const router = useRouter();

const isActive = (href) => {
  return route.path === href;
};

const resalesNavigation = ref([]);
const resaleSelected = ref({ name: "", cnpj: "", logo: "" });
const isLoadingApp = ref(true);
const hasInitiallyLoaded = ref(false);

const profile = ref();

provide("profile", profile);

provide(
  "tenant",
  computed(() => resaleSelected)
);

const getProfileInfo = async () => {
  try {
    isLoadingApp.value = true;
    const {
      data: { resales },
    } = await httpService.get(`/resales`);

    if (window.localStorage.getItem("cnpj")) {
      const selectedResale = resales.find(
        (resale) => resale.cnpj === window.localStorage.getItem("cnpj")
      );
      if (selectedResale) {
        resaleSelected.value = {
          name: selectedResale.razao_social,
          cnpj: selectedResale.cnpj,
          logo: selectedResale.logo || "",
        };
      }
    }

    resalesNavigation.value = resales.map((resale) => ({
      name: resale.razao_social,
      cnpj: resale.cnpj,
      logo: resale.logo || "",
      action: (item) => changeResale(item),
    }));

    window.localStorage.setItem("cnpj", resales[0].cnpj);

    if (resales.length === 1) {
      window.localStorage.setItem("cnpj", resales[0].cnpj);
      resaleSelected.value = {
        name: resales[0].razao_social,
        cnpj: resales[0].cnpj,
        logo: resales[0].logo || "",
        action: (item) => changeResale(item),
      };
    }
  } catch (error) {
    console.log(error);
  } finally {
    isLoadingApp.value = false;
    hasInitiallyLoaded.value = true;
  }
};

const changeResale = async (resale: {
  name: string;
  cnpj: string;
  logo?: string;
}) => {
  resaleSelected.value = {
    name: resale.name,
    cnpj: resale.cnpj,
    logo: resale.logo || "",
  };
  window.localStorage.setItem("cnpj", resale.cnpj);
};

const handleLogoError = (event: Event) => {
  // Ocultar a imagem se houver erro no carregamento
  const img = event.target as HTMLImageElement;
  if (img) {
    img.style.display = "none";
  }
};

function formatCNPJ(cnpj: string): string {
  if (!cnpj) return "";
  return cnpj.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
    "$1.$2.$3/$4-$5"
  );
}

const logout = () => {
  KeycloakService.callLogOut();
  window.localStorage.clear();
};

const goToComprar = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
  router.push({ path: "/comprar" });
};

const goToComprarAndClose = () => {
  sidebarOpen.value = false;
  goToComprar();
};

onMounted(async () => {
  await getProfileInfo();
});

const sidebarOpen = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: "-m-2.5 p-2.5 text-parrot-1 lg:hidden",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (sidebarOpen.value = true))
        }, [
          _hoisted_3,
          _createVNode(_unref(Bars3Icon), {
            class: "h-6 w-6",
            "aria-hidden": "true"
          })
        ]),
        _hoisted_4
      ]),
      _createElementVNode("ul", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_unref(Menu), {
              as: "div",
              class: "relative"
            }, {
              default: _withCtx(() => [
                (isLoadingApp.value || !resaleSelected.value.name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
                  : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "inline-flex items-center bg-parrot-2 text-white text-sm px-3 py-1.5 rounded-md hover:bg-opacity-90 transition-all duration-200 mr-2",
                        onClick: goToComprar
                      }, " Nova licença "),
                      _createVNode(_unref(MenuButton), { class: "flex items-center p-1.5 border-parrot-1 border rounded-md w-44 lg:w-52" }, {
                        default: _withCtx(() => [
                          _hoisted_13,
                          (resaleSelected.value.logo)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("img", {
                                  src: `data:image/png;base64,${resaleSelected.value.logo}`,
                                  alt: `Logo ${resaleSelected.value.name}`,
                                  class: "w-10 h-10 rounded object-cover pointer-events-none select-none",
                                  onError: handleLogoError
                                }, null, 40, _hoisted_15)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: _normalizeClass([
                    'flex flex-col flex-1 min-w-0',
                    !resaleSelected.value.logo
                      ? 'items-center justify-center text-center'
                      : '',
                  ])
                          }, [
                            _createElementVNode("span", _hoisted_16, [
                              _createElementVNode("span", _hoisted_17, _toDisplayString(resaleSelected.value.name), 1),
                              (resalesNavigation.value.length > 1)
                                ? (_openBlock(), _createBlock(_unref(ChevronDownIcon), {
                                    key: 0,
                                    class: "ml-2 h-4 w-4 text-white flex-shrink-0",
                                    "aria-hidden": "true"
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("span", _hoisted_18, [
                              _createElementVNode("span", _hoisted_19, _toDisplayString(formatCNPJ(resaleSelected.value.cnpj)), 1)
                            ])
                          ], 2)
                        ]),
                        _: 1
                      })
                    ])),
                (!isLoadingApp.value && resaleSelected.value.name)
                  ? (_openBlock(), _createBlock(_Transition, {
                      key: 2,
                      "enter-active-class": "transition ease-out duration-100",
                      "enter-from-class": "transform opacity-0 scale-95",
                      "enter-to-class": "transform opacity-100 scale-100",
                      "leave-active-class": "transition ease-in duration-75",
                      "leave-from-class": "transform opacity-100 scale-100",
                      "leave-to-class": "transform opacity-0 scale-95"
                    }, {
                      default: _withCtx(() => [
                        (resalesNavigation.value.length > 1)
                          ? (_openBlock(), _createBlock(_unref(MenuItems), {
                              key: 0,
                              class: "absolute right-0 z-10 mt-2.5 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resalesNavigation.value, (item) => {
                                  return (_openBlock(), _createBlock(_unref(MenuItem), {
                                    key: item.cnpj,
                                    onClick: ($event: any) => (item.action(item)),
                                    class: "flex flex-row space-x-2 hover:cursor-pointer"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", {
                                        class: _normalizeClass([
                      item.cnpj === resaleSelected.value.cnpj
                        ? 'bg-parrot text-white'
                        : '',
                      'block px-3 py-1 text-sm leading-6 text-parrot',
                    ])
                                      }, [
                                        (item.cnpj === resaleSelected.value.cnpj)
                                          ? (_openBlock(), _createElementBlock("span", {
                                              key: 0,
                                              class: _normalizeClass([
                        item.cnpj === resaleSelected.value.cnpj
                          ? 'text-white'
                          : 'text-parrot',
                        'inset-y-0 left-0 flex items-center',
                      ])
                                            }, [
                                              _createVNode(_unref(CheckIcon), {
                                                class: "h-5 w-5",
                                                "aria-hidden": "true"
                                              })
                                            ], 2))
                                          : _createCommentVNode("", true),
                                        _createTextVNode(" " + _toDisplayString(formatCNPJ(item.cnpj)), 1)
                                      ], 2)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                }), 128))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: sidebarOpen.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          class: "relative z-50 lg:hidden",
          onClose: _cache[3] || (_cache[3] = ($event: any) => (sidebarOpen.value = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "transition-opacity ease-linear duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "transition-opacity ease-linear duration-300",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "transition ease-in-out duration-300 transform",
                "enter-from": "-translate-x-full",
                "enter-to": "translate-x-0",
                leave: "transition ease-in-out duration-300 transform",
                "leave-from": "translate-x-0",
                "leave-to": "-translate-x-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), { class: "relative mr-16 flex w-full max-w-xs flex-1" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TransitionChild), {
                        as: "template",
                        enter: "ease-in-out duration-300",
                        "enter-from": "opacity-0",
                        "enter-to": "opacity-100",
                        leave: "ease-in-out duration-300",
                        "leave-from": "opacity-100",
                        "leave-to": "opacity-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "-m-2.5 p-2.5",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (sidebarOpen.value = false))
                            }, [
                              _hoisted_23,
                              _createVNode(_component_XMarkIcon, {
                                class: "h-6 w-6 text-white",
                                "aria-hidden": "true"
                              })
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            (resaleSelected.value.logo)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                  _createElementVNode("img", {
                                    src: `data:image/png;base64,${resaleSelected.value.logo}`,
                                    alt: `Logo ${resaleSelected.value.name}`,
                                    class: "w-14 h-14 rounded object-cover pointer-events-none select-none",
                                    onError: handleLogoError
                                  }, null, 40, _hoisted_28)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", {
                              class: _normalizeClass([
                      'flex flex-col flex-1 min-w-0 text-white',
                      !resaleSelected.value.logo
                        ? 'items-center justify-center text-center'
                        : '',
                    ])
                            }, [
                              _createElementVNode("div", _hoisted_29, _toDisplayString(resaleSelected.value.name), 1),
                              _createElementVNode("div", _hoisted_30, _toDisplayString(formatCNPJ(resaleSelected.value.cnpj)), 1)
                            ], 2)
                          ])
                        ]),
                        _createElementVNode("nav", _hoisted_31, [
                          _createElementVNode("ul", _hoisted_32, [
                            _createElementVNode("li", null, [
                              _createElementVNode("ul", _hoisted_33, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
                                  return _createElementVNode("li", {
                                    key: item.name
                                  }, [
                                    _createElementVNode("a", {
                                      href: item.href,
                                      class: _normalizeClass([
                            isActive(item.href)
                              ? 'bg-white bg-opacity-5 text-parrot-1'
                              : 'text-white hover:text-parrot-1 hover:bg-white hover:bg-opacity-5',
                            'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold',
                          ])
                                    }, [
                                      (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                                        class: _normalizeClass([
                              isActive(item.href)
                                ? 'text-parrot-1'
                                : 'text-white group-hover:text-parrot-1',
                              'h-6 w-6 shrink-0',
                            ]),
                                        "aria-hidden": "true"
                                      }, null, 8, ["class"])),
                                      _createTextVNode(" " + _toDisplayString(item.name), 1)
                                    ], 10, _hoisted_34)
                                  ])
                                }), 64))
                              ])
                            ]),
                            _createElementVNode("li", _hoisted_35, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "group -mx-2 flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 bg-parrot-2 text-white hover:bg-opacity-90 transition-all duration-200 mb-3 w-full justify-center",
                                onClick: goToComprarAndClose
                              }, " Nova licença "),
                              _createElementVNode("button", {
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (logout())),
                                class: "group -mx-2 flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-white hover:bg-white hover:bg-opacity-5 hover:text-parrot-1 w-full justify-center"
                              }, [
                                _createVNode(_unref(ArrowLeftEndOnRectangleIcon), {
                                  class: "h-6 w-6 shrink-0 text-white group-hover:text-parrot-1",
                                  "aria-hidden": "true"
                                }),
                                _createTextVNode(" Sair ")
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("nav", _hoisted_38, [
          _createElementVNode("ul", _hoisted_39, [
            _createElementVNode("li", null, [
              _createElementVNode("ul", _hoisted_40, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
                  return _createElementVNode("li", {
                    key: item.name
                  }, [
                    _createElementVNode("a", {
                      href: item.href,
                      class: _normalizeClass([
                    isActive(item.href)
                      ? 'bg-white bg-opacity-5 text-parrot-1'
                      : 'text-white hover:text-parrot-1 hover:bg-white hover:bg-opacity-5',
                    'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold',
                  ])
                    }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                        color: isActive(item.href) ? '#B2FF59' : 'white',
                        class: _normalizeClass([
                      isActive(item.href)
                        ? 'text-parrot-1'
                        : 'text-white group-hover:text-parrot-1',
                      'h-6 w-6 shrink-0',
                    ]),
                        "aria-hidden": "true"
                      }, null, 8, ["color", "class"])),
                      _createTextVNode(" " + _toDisplayString(item.name), 1)
                    ], 10, _hoisted_41)
                  ])
                }), 64))
              ])
            ]),
            _createElementVNode("li", _hoisted_42, [
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (logout())),
                class: "group -mx-2 flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-white hover:bg-white hover:bg-opacity-5 hover:text-parrot-1 w-full text-left"
              }, [
                _createVNode(_unref(ArrowLeftEndOnRectangleIcon), {
                  class: "h-6 w-6 shrink-0 text-white group-hover:text-parrot-1",
                  "aria-hidden": "true"
                }),
                _createTextVNode(" Sair ")
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createElementVNode("main", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          (isLoadingApp.value && !hasInitiallyLoaded.value)
            ? (_openBlock(), _createBlock(ClientListSkeleton, { key: 0 }))
            : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
        ])
      ])
    ])
  ], 64))
}
}

})